import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { SignOut } from "@phosphor-icons/react";

export default function PortalLayout({ title, links }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="page-enter">
      <div className="border-b border-white/10 bg-white/[0.02]">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-10 flex flex-wrap items-end justify-between gap-6">
          <div>
            <div className="overline mb-2">{title.overline}</div>
            <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-white">{title.heading}</h1>
            {user && <div className="mt-2 text-sm text-zinc-400 font-mono">{user.email} · {user.role}</div>}
          </div>
          <button
            className="btn-outline"
            onClick={async () => { await logout(); nav("/"); }}
            data-testid="portal-signout"
          >
            <SignOut size={16} /> Sign out
          </button>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-10 grid lg:grid-cols-12 gap-8">
        <aside className="lg:col-span-3">
          <nav className="border border-white/10 rounded-xl overflow-hidden divide-y divide-white/10 sticky top-24 bg-white/[0.02]">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`portal-link-${l.to.replace(/\//g, "-")}`}
                className={({ isActive }) =>
                  `block px-4 py-3 text-sm transition-colors ${
                    isActive
                      ? "bg-blue-500 text-white font-semibold"
                      : "text-zinc-300 hover:bg-white/[0.04] hover:text-white"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <div className="lg:col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
